import { render, staticRenderFns } from "./DictRadioGroup.vue?vue&type=template&id=5bc7b608&scoped=true&"
import script from "./DictRadioGroup.vue?vue&type=script&lang=js&"
export * from "./DictRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7b608",
  null
  
)

export default component.exports